import React, { useState, useEffect, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { Routes, Route, Navigate, Link, useNavigate, useLocation } from 'react-router-dom';
import Funds from './funds';
import Plans from './iconpages/plans';
import Dashboard from './iconpages/dashboard';
import Checklist from './iconpages/checklist';
import nusLogo from "./img/nus-logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faBuilding, faHome, faBriefcase, faDollarSign, faTachometerAlt, faListAlt, faCog, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import Homeacc from './usericonpage/homeacc';
import ChecklistAcc from './usericonpage/checklistacc';
import Dashboardacc from './usericonpage/dashboardacc';
import Login from './Login'; 
import Profile from './usericonpage/profile';
import { ToastContainer } from 'react-toastify';
import { showToast } from './toastUtils';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
//import useIdleLogout from './activity-tracker';
import { queuedApiFetch, apiFetch } from './api';
import FullscreenLoader from './FullscreenLoader';
// import { useSingleTab } from "./singleTab";


function RouteGuard({ children }) {
  const navigate = useNavigate();

  useEffect(() => {
    const projectDetails = localStorage.getItem('projectDetails');
    const checkUserDetail = localStorage.getItem('userDetails');
    const checkLogedIn = localStorage.getItem('isLoggedIn');
    const checkAccountId = localStorage.getItem('accountId');
    const checkUserEmail = localStorage.getItem('userEmail');

    if(!checkUserDetail || !checkLogedIn || !checkAccountId || !checkUserEmail){
      localStorage.removeItem('isLoggedIn');      
      localStorage.removeItem('accountId');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userDetails');
      localStorage.removeItem('userCompany');
      localStorage.setItem('lastActiveRoute', '/login');
      navigate('/login');
    }else if (!projectDetails) {
      Swal.fire({
        title: 'Missing Project Details',
        text: 'Please select a project before proceeding.',
        icon: 'warning',
        confirmButtonText: 'Go to Home Page',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed){
          localStorage.setItem('lastActiveRoute', '/homeacc');
          navigate('/homeacc');
        }                  
      });
    }

  }, [navigate]);

  const projectDetails = localStorage.getItem('projectDetails');
  if (!projectDetails) {
    return null; // Prevent rendering of children if projectDetails is missing
  }

  return children;
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userMenuVisible, setUserMenuVisible] = useState(true);
  const [plansMenuVisible, setPlansMenuVisible] = useState(false);
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState('/homeacc');
  const location = useLocation();
  const [selectedProject, setSelectedProject] = useState(''); 
  // const [projectName, setProjectName] = useState([]);
  const [isFetched, setIsFetched] = useState(false); 
  const [userCompany, setUserCompany] = useState();
  const [userPermission, setUserPermission] = useState();
  const [getUserEmail, setGetUserEmail] = useState();
  const getUserCompanyDetails =userCompany;
  const [userRoleManual, setUserRolesManual] = useState();
  const [proj_access_level, setProjAccessLevel] = useState(false);
  const [loading, setLoading] = useState(false);

  const [blockTab, setBlockTab] = useState(false);

  const [showIdlePopup, setShowIdlePopup] = useState(false);
  const [countdown, setCountdown] = useState(60);

  const intervalRef = useRef(null);
  const idlePopupOpenRef = useRef(false);

  useEffect(() => {
  const channel = new BroadcastChannel("NUS_SINGLE_TAB");

  channel.postMessage("TAB_OPENED");

  channel.onmessage = (event) => {
    if (event.data === "TAB_OPENED") {
      setBlockTab(true);
      alert("Only one tab is allowed. Please close other tabs.");
    }
  };

  return () => {
    channel.postMessage("TAB_CLOSED");
    channel.close();
    setBlockTab(false);
  };
}, []);

  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
  const userId = userDetails ? userDetails.id : '';

  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = getProjectDetails ? JSON.parse(getProjectDetails) : null;
  const defaultProjectNumber = selectedProjectDetail ? selectedProjectDetail.projectNumber : null;
  let parametervalue;
  

    // Define the global submitForm function
 if(isLoggedIn){
    // variable declaration
    const accountId = localStorage.getItem('accountId');
    const getProjectDetails = localStorage.getItem('projectDetails');

    if(getUserCompanyDetails==="NUS"){
      parametervalue=1;
    }else{
      parametervalue=0;
    }

    if(getProjectDetails) {
    
    
    const selectedProjectDetail = JSON.parse(getProjectDetails);
    const projectName = selectedProjectDetail.projectName;
    const defaultProjectNumber = selectedProjectDetail.projectNumber;
    
    // let parametervalue;

    // if(getUserCompanyDetails==="NUS"){
    //   parametervalue=1;
    // }else{
    //   parametervalue=0;
    // }

    
    
    // window.submitform = (template_name, formData, menu) => {
    //   const form = document.createElement('form');
    //   form.method = 'POST';
    //   form.action = `${process.env.REACT_APP_BACKEND_URL}/form_template/form_post`;

    //   // Append dynamic form data
    //   formData.append('account_id', accountId);          
    //   formData.append('project_id', defaultProjectNumber);
    //   formData.append('menu', menu);                      
    //   formData.append('nususer', parametervalue);         
    //   formData.append('template_name', template_name);
    //   formData.append('email_id', getUserEmail);


    //   // Append FormData fields as hidden inputs
    //   for (const [key, value] of formData.entries()) {
    //     const input = document.createElement('input');
    //     input.type = 'hidden';
    //     input.name = key;
    //     input.value = value;
    //     form.appendChild(input);
    //   }

    //   // Append the form to the document and submit it
    //   document.body.appendChild(form);
    //   form.submit();
    // };

    // window.submitform = (template_name, rawFormData, menu) => {
    //   console.log('template_name:', template_name);

    //   const formData = new FormData();
    //   formData.append('account_id', accountId);          
    //   formData.append('project_id', defaultProjectNumber);
    //   formData.append('menu', menu);                      
    //   formData.append('nususer', parametervalue);         
    //   formData.append('template_name', template_name);
    //   formData.append('email_id', getUserEmail);
  
    //   if (rawFormData && rawFormData instanceof FormData) {
    //     for (const [key, value] of rawFormData.entries()) {
    //       formData.append(key, value);
    //     }
    //   }

    //   const form = document.createElement('form');
    //   form.method = 'POST';
    //   form.action = `${process.env.REACT_APP_BACKEND_URL}/form_template/form_post`;
    
    //   for (const [key, value] of formData.entries()) {
    //     const input = document.createElement('input');
    //     input.type = 'hidden';
    //     input.name = key;
    //     input.value = value;
    //     form.appendChild(input);
    //   }
    
    //   document.body.appendChild(form);
    //   form.submit();
    // };

      window.submitform = async (template_name, rawFormData, menu, retry_no = 0) => {
        //console.log('template_name:', template_name);
        let p_access = selectedProjectDetail?.Proj_Access?.proj_access_level;
        let p_roles = selectedProjectDetail?.Proj_Access?.proj_role.join(", ");
        let proj_name=selectedProjectDetail?.projectName;
        const email = await getUserEmailFunction();
        // let qs_params = `nususer=${parametervalue}&project_admin=${(p_access) ? 1 : 0}&project_roles=${p_roles}&menu=${menu}`;
          setLoading(true);
        // Prepare request body
        const requestBody = {
          account_id: accountId,
          project_id: defaultProjectNumber,
          project_name: proj_name,
          menu: menu,
          nususer: parametervalue,
          template_name: template_name,
          email_id: email,
          retry_no: retry_no,
          project_admin: (p_access) ? 1 : 0,
          project_roles: p_roles,          
        };

        // Add additional fields from rawFormData if it exists
        if (rawFormData && rawFormData instanceof FormData) {
          for (const [key, value] of rawFormData.entries()) {
            requestBody[key] = value;
          }
        }

        const requestOptions = {
          method: 'POST',
          body: JSON.stringify(requestBody),
        };

        try {
          const response = await queuedApiFetch(`/form_template/form_post`, requestOptions);
          const result = await response; // FormResponse
          // if (result.apistatus.Status_Code !== 200) {
          //   throw new Error(`HTTP error! Status: ${response.status}`);
          // }

          if (result?.apistatus?.Status_Code === 200 ) {
            // Success
            if (result?.data?.form_sts) {
              showToast.success('Form created successfully');
              // redirect to form_url in same tab             
              if (result.data.form_url) {

                setTimeout(() => {
                  // let url=result.data.form_url;
                  // url = url.split("?")[0] + "?" + qs_params;
                  // window.location.href = url;
                  window.location.href = result.data.form_url;
                }, 2000);
               
              }
              return result;
            }
            // Retry logic
            else {

              showToast.warn(result?.apistatus?.Status_Description);
              //setLoading(false);
              //showToast.warn('acc is not currently initiating form, retry later');

              // if (result.data.retry_no < 2) {
              //   //console.warn(`Retry attempt ${result.data.retry_no + 1}...`);
              //   return window.submitform(template_name, rawFormData, menu, result.data.retry_no + 1);
              // } else {
              //   //console.error("Maximum retry attempts reached.");
              //   return result;
              // }

            }
          }
          else{
              showToast.error(result.apistatus.Status_Description);
          }
          

          //console.log("FormResponse:", result);

        } catch (error) {
          setLoading(false);
          console.error("Form submission failed:", error);
          throw error;
        }
        finally{
          setLoading(false);
        }
      };

  }
  }

  const getQueryParams = (proj_access, nus_user_sts) => {

    let p_access = proj_access?.proj_access_level;
    let p_roles = proj_access?.proj_role.join(", ");
    p_roles = p_roles ? p_roles : '';
    let proj_name=selectedProjectDetail?.projectName;
    proj_name = proj_name ? proj_name : '';

    let qs_params = `nususer=${nus_user_sts}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;

    return qs_params;
  };
    // Wait for userDetails if not immediately available
  const waitForUserDetails = () => {
      return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          clearInterval(interval);
          // reject('Timeout: userDetails not found in time');
        }, 2000);
        const interval = setInterval(() => {
          const userDetails = localStorage.getItem('userDetails');
          if (userDetails) {
            clearTimeout(timeout);
            clearInterval(interval);
            const parsed = JSON.parse(userDetails);
            const email = parsed.email;
            localStorage.setItem('userEmail', email);
            resolve(email);
          }
        }, 10);
      });
  };
    
    // Get user email from localStorage or wait for userDetails
    const getUserEmailFunction = async () => {
      if (localStorage.getItem('userEmail')) {
        const userEmail = localStorage.getItem('userEmail');
        setGetUserEmail(userEmail);
        return userEmail;
      } else if (localStorage.getItem('userDetails')) {
        const parsed = JSON.parse(localStorage.getItem('userDetails'));
        const email = parsed.email;
        setGetUserEmail(email);
        localStorage.setItem('userEmail', email);
        return email;
      } else {
        // console.warn('userDetails not found, waiting...');
        const email = await waitForUserDetails();
        setGetUserEmail(email);
        return email;
      }
    };
    
    // Fetch user profile (company + permission)
    const fetchUserCompany = async (email) => {
      if (isFetched || !email) return;
    
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
      };
    
      try {
        const response = await queuedApiFetch(`/user/getuserprofile?emailid=${email}`,
          requestOptions
        );
        const data = await response;
    
        if (
          data.apistatus.Status_Code === 200 &&
          data.apistatus.Status_Description.toLowerCase() === 'success'
        ) {
          setIsFetched(true);
          setUserCompany(data.data.company_name);
          setUserPermission(data.data.access_level);

          localStorage.setItem("userCompany", JSON.stringify(data.data.company_name));

          // let user = JSON.parse(localStorage.getItem("userDetails")) || {};
          // user.company = data.data.company_name;
          // localStorage.setItem("userDetails", JSON.stringify(user));
          // setUserCompany('UAT Maincon A');
          //setUserPermission('project_admin');
          //setUserPermission('project_user');
        }
      } catch (error) {
        console.error('Error fetching company data:', error);
      }
    };

  const fetchUserRole = async () => {

    if (!userId || !defaultProjectNumber) {
      return;
    }

    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
    try {
      const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${defaultProjectNumber}`, requestOptions);
      const data = await response;

      if (data.apistatus?.Status_Code === 200 && data.apistatus?.Status_Description.toLowerCase() === 'success') {
        // console.log(data.data); 
        setUserRolesManual(data.data);
        setProjAccessLevel(data.access_level);
        //setUserRolesManual('Consultant');
        //setUserRolesManual('Project Director (PD)');
        //setUserRolesManual('Admin & Contract (AC)');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      //   setLoading(false); // End loading
    }
  }
    
    // Fetch updated userDetails
    const userUpdates = async (email) => {
      if (!email) return;
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
      };
      try {
        const response = await queuedApiFetch(`/user/checkuser?emailid=${email}`,
          requestOptions
        );
        const data = await response;
    
        if (
          data.apistatus.Status_Code === 200 &&
          data.apistatus.Status_Description.toLowerCase() === 'success'
        ) {
          localStorage.setItem('userDetails', JSON.stringify(data.data));
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };
    
    // Main useEffect optimized for performance
    //  useEffect(() => {
    //   const fetchData = async () => {
    //     try {
    //       const email = await getUserEmailFunction();
    //       // console.log('getUserEmail:', email);
    //       if (!email) return;
    //       await Promise.all([
    //         fetchUserCompany(email),
    //         fetchUserRole(),
    //         userUpdates(email),
    //       ]);
    //       // const urlParams = new URLSearchParams(window.location.search);
    //       // const activeParam = urlParams.get('active');
    //       // if (activeParam === 'true') {
    //       //   const projectDetails = localStorage.getItem('projectDetails');
    //       //   if (projectDetails) {
    //       //     const project = JSON.parse(projectDetails);
    //       //     setProjectName(project.projectName);
    //       //     goToSelectedProject(project.projectNumber, project.projectName);
    //       //   } else {
    //       //     // console.log('No projectDetails found in localStorage.');
    //       //   }
    //       // }
    //     } catch (error) {
    //       console.error('Error in fetchData:', error);
    //     }
    //   };
    //   // if(isLoggedIn){
    //   //   fetchData();
    //   // }
    //   fetchData();
    // }, []);

    //   const goToSelectedProject = (projectNumber,projectName) => {
    //     // const selectedProject = projectName.find(project => project.number === getprojectName);
    //     // if (selectedProject) {
    //         setSelectedProject(projectName);            
    //         localStorage.setItem('projectDetails', JSON.stringify({
    //             projectName: projectName,
    //             projectNumber: projectNumber,
    //             // URN: selectedProject.urn
    //         }));
    //         localStorage.setItem('lastActiveRoute', '/plans');
    //         navigate('/plans');
    //     // }
    //   }

    useEffect(() => {
      if (!isLoggedIn) return;
      
      const fetchData = async () => {
        try {
          const email = await getUserEmailFunction();
          // console.log('getUserEmail:', email);
          if (!email) return;
          await Promise.all([
            fetchUserCompany(email),       
            fetchUserRole(),
            userUpdates(email),
          ]);          
        } catch (error) {
          console.error('Error in fetchData:', error);
        }
      };
      // if(isLoggedIn){
      //   fetchData();
      // }
      fetchData();
    }, [isLoggedIn]);

    

      const goToSelectedProject = (projectNumber,projectName) => {
        // const selectedProject = projectName.find(project => project.number === getprojectName);
        // if (selectedProject) {
            setSelectedProject(projectName);            
            localStorage.setItem('projectDetails', JSON.stringify({
                projectName: projectName,
                projectNumber: projectNumber,
                // URN: selectedProject.urn
            }));
            localStorage.setItem('lastActiveRoute', '/plans');
            navigate('/plans');
        // }
      }
      
      
  // useEffect(() => {
  //   if (window.location.pathname === '/homeacc') {
  //     setUserMenuVisible(true); // Reset the user menu to visible when navigating to /homeacc
  //     setPlansMenuVisible(false);
  //   }
  // }, [window.location.pathname]);


  useEffect(() => {    
    const targetPaths = ['/plans', '/funds', '/dashboard', '/checklist'];    
    if (targetPaths.includes(location.pathname)) {
      togglePlansMenu();
    } else {
      toggleUserMenu();
    }
  }, [location.pathname]);
  
  useEffect(() => {
    if (plansMenuVisible && isLoggedIn) {
      fetchUserRole();
    }
  }, [plansMenuVisible, isLoggedIn]);
  
  //Old code
  useEffect(() => {
    // if(isLoggedIn){
    //   fetchUserCompany();
    //   fetchUserRole();
    // }

    // fetchUserCompany();
    // fetchUserRole();

    const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(loggedIn);
    const checkSearch = location.search;
    const lastActiveRoute = localStorage.getItem('lastActiveRoute');
    // console.log('lastActiveRoute', lastActiveRoute);
    // Check if the current URL is '/'
    if (location.pathname === '/') {
      if (!loggedIn) {
        // handleLogout();
        navigate('/login');
      } else {
        fetchUserCompany();
        fetchUserRole();
        navigate('/homeacc');
        localStorage.setItem('lastActiveRoute', '/homeacc');
        return;
      }
    }
    if (location.pathname === '/funds' || location.pathname === '/homeacc' || location.pathname === '/plans' || location.pathname === '/checklist' || location.pathname === '/dashboard' || location.pathname === '/dashboardacc' || location.pathname === '/checklistacc') {
      if (!loggedIn) {
        localStorage.setItem('lastActiveRoute', '/');
        navigate('/');
        return;
      }
    }
    // Retrieve the active route from localStorage if available

    const fullPath = location.pathname + location.search;
    if (lastActiveRoute && checkSearch == '' && fullPath==='/homeacc') {
      setActiveLink(lastActiveRoute);
      navigate(lastActiveRoute); // Navigate to the stored route
    } else {
      if (checkSearch.includes('logout')) {
        handleLogout()
      } else {
        // const fullPath = location.pathname + location.search;
        localStorage.setItem('lastActiveRoute', fullPath);
        setActiveLink(location.pathname);
        navigate(fullPath);
      }
    }
  }, [navigate]);


//   useEffect(() => {

//   const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
//   setIsLoggedIn(loggedIn);

//   const checkSearch = location.search;
//   const lastActiveRoute = localStorage.getItem('lastActiveRoute');

//   const validRoutes = [
//     '/funds',
//     '/homeacc',
//     '/plans',
//     '/checklist',
//     '/dashboard',
//     '/dashboardacc',
//     '/checklistacc'
//   ];

//   const currentPath = location.pathname;
//   const fullPath = currentPath + location.search;

//   // 1. ROOT HANDLING
//   if (currentPath === '/') {
//     if (!loggedIn) {
//       navigate('/login');
//       return;
//     } else {
//       fetchUserCompany();
//       fetchUserRole();

//       localStorage.setItem('lastActiveRoute', '/homeacc');
//       navigate('/homeacc');
//       return;
//     }
//   }

//   // 2. NOT LOGGED IN → BLOCK ALL PROTECTED ROUTES
//   if (validRoutes.includes(currentPath) && !loggedIn) {
//     localStorage.setItem('lastActiveRoute', '/');
//     navigate('/');
//     return;
//   }

//   // 3. LOGOUT HANDLING
//   if (checkSearch.includes('logout')) {
//     handleLogout();
//     return;
//   }

//   // 4. VALID ROUTE → ALWAYS TRUST URL (IMPORTANT FIX)
//   if (validRoutes.includes(currentPath)) {

//     setActiveLink(currentPath);
//     localStorage.setItem('lastActiveRoute', fullPath);

//     // ONLY navigate if needed (prevents loop)
//     if (window.location.pathname !== currentPath) {
//       navigate(currentPath, { replace: true });
//     }

//     return;
//   }

//   // 5. INVALID ROUTE → fallback ONLY
//   if (lastActiveRoute && checkSearch === '') {

//     // IMPORTANT: prevent override of correct URL
//     if (lastActiveRoute !== currentPath) {
//       setActiveLink(lastActiveRoute);
//       navigate(lastActiveRoute, { replace: true });
//     }

//   } else {

//     localStorage.setItem('lastActiveRoute', fullPath);
//     setActiveLink(currentPath);
//   }

// }, [location.pathname, location.search]);

  // useEffect(() => {
  //   const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
  //   setIsLoggedIn(loggedIn);

  //   const lastActiveRoute = localStorage.getItem('lastActiveRoute');

  //   const currentPath = location.pathname;
  //   const currentSearch = location.search;
  //   const fullPath = currentPath + currentSearch;

  //   // ❌ Block access if not logged in for protected routes
  //   const protectedRoutes = [
  //     '/funds',
  //     '/homeacc',
  //     '/plans',
  //     '/checklist',
  //     '/dashboard',
  //     '/dashboardacc',
  //     '/checklistacc'
  //   ];

  //   if (!loggedIn && protectedRoutes.includes(currentPath)) {
  //     localStorage.setItem('lastActiveRoute', '/');
  //     navigate('/');
  //     return;
  //   }

  //   // ✅ Handle root route only
  //   if (currentPath === '/') {
  //     if (!loggedIn) {
  //       navigate('/login');
  //       return;
  //     } else {
  //       fetchUserCompany();
  //       fetchUserRole();

  //       const defaultRoute = '/homeacc';
  //       localStorage.setItem('lastActiveRoute', defaultRoute);

  //       if (location.pathname !== defaultRoute) {
  //         navigate(defaultRoute);
  //       }
  //       return;
  //     }
  //   }

  //   // ❌ Handle logout query
  //   if (currentSearch.includes('logout')) {
  //     handleLogout();
  //     return;
  //   }

  //   // ✅ IMPORTANT FIX:
  //   // Always respect current URL first
  //   // Only store it, DO NOT override it with lastActiveRoute

  //   localStorage.setItem('lastActiveRoute', fullPath);
  //   setActiveLink(currentPath);

  //   // Navigate only if URL mismatch (prevents loops / overrides)
  //   if (location.pathname + location.search !== fullPath) {
  //     navigate(fullPath, { replace: true });
  //   }

  // }, [location.pathname, location.search, navigate]);

//   useEffect(() => {
//   const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
//   setIsLoggedIn(loggedIn);

//   const currentPath = location.pathname;
//   const currentSearch = location.search;

//   const fullPath = currentPath + currentSearch;

//   const protectedRoutes = [
//     '/funds',
//     '/homeacc',
//     '/plans',
//     '/checklist',
//     '/dashboard',
//     '/dashboardacc',
//     '/checklistacc'
//   ];

//   // ❌ BLOCK UNAUTH ACCESS
//   if (!loggedIn && protectedRoutes.includes(currentPath)) {
//     navigate('/login', { replace: true });
//     return;
//   }

//   // ✅ ROOT ROUTE ONLY HANDLING
//   if (currentPath === '/') {
//     if (!loggedIn) {
//       navigate('/login', { replace: true });
//       return;
//     }

//     fetchUserCompany();
//     fetchUserRole();

//     localStorage.setItem('lastActiveRoute', '/homeacc');

//     navigate('/homeacc', { replace: true });
//     return;
//   }

//   // ❌ REMOVE AUTO NAVIGATE TO lastActiveRoute COMPLETELY
//   // THIS WAS OVERRIDING ALL URLS

//   // ✅ JUST STORE CURRENT ROUTE (DO NOT REDIRECT)
//   localStorage.setItem('lastActiveRoute', fullPath);
//   setActiveLink(currentPath);

// }, [location.pathname, location.search]);

  const toggleUserMenu = () => {
    setUserMenuVisible(true);
    setPlansMenuVisible(false);
  };

  const togglePlansMenu = () => {
    setPlansMenuVisible(true);
    setUserMenuVisible(false);
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true'); // Store the login state  
  };

  // const handleLogout = () => {
    // setShowSettings(false);
    // setIsLoggedIn(false);
  //   localStorage.removeItem('isLoggedIn'); // Clear the login state
  //   localStorage.removeItem('lastActiveRoute'); // Clear the last active route on logout
  //   localStorage.removeItem('accountId');
  //   localStorage.removeItem('userEmail');
  //   localStorage.removeItem('userDetails');
  //   localStorage.removeItem('projectURN');
  // };

  const handleLogout = () => {
    setShowSettings(false);
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('lastActiveRoute');
    localStorage.removeItem('accountId');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('projectURN');
    localStorage.removeItem('userCompany');

    //approch 1
    // const postLogoutRedirectUri = window.location.origin; 
    // const logoutUrl = `https://developer.api.autodesk.com/authentication/v2/logout?post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri)}`;
    // window.location.href = logoutUrl;

    //approch 2
     window.location.href = `${process.env.REACT_APP_BACKEND_URL}/autodesk/logout`;
  
  };
  
  const [showSettings, setShowSettings] = useState(false);
  const settingsPopupRef = useRef(null);

  // Toggle visibility of settings popup
  const toggleSettings = (event) => {
    event.stopPropagation();
    setShowSettings(prevShowSettings => !prevShowSettings);
  };

  // Close popup if click is outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (settingsPopupRef.current && !settingsPopupRef.current.contains(event.target)) {
        setShowSettings(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleClick = () => {
    localStorage.setItem('lastActiveRoute', '/profile');
    setShowSettings(false);
    navigate('/profile');
  };

  const handleManageAccount = () => {
    const accountId = localStorage.getItem('accountId');
    const getProjectDetails = localStorage.getItem('projectDetails');
    const selectedProjectDetail = JSON.parse(getProjectDetails);
    const defaultProjectNumber = selectedProjectDetail?.projectNumber;
    const BASE_URL_ACC = 'https://acc.autodesk.com'
    
    let qs_params=getQueryParams(selectedProjectDetail?.Proj_Access,parametervalue);
    if(userMenuVisible){
      // nagivate to manage account page
      window.location.href = `${BASE_URL_ACC}/account-admin/members/accounts/${accountId}?${qs_params}`
    } else {
      if(!defaultProjectNumber){
        showToast.warning("Select any project !");
        return;
      }
      // nagivate to manage project page
      window.location.href = `${BASE_URL_ACC}/project-admin/members/projects/${defaultProjectNumber}?${qs_params}`
    }
   
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
    localStorage.setItem('lastActiveRoute', link); // Store the active route
  };

  //Activity tracker - Automatic logout after 30 minutes of inactivity
  //useIdleLogout(isLoggedIn ? 30 * 60 * 1000 : null, handleLogout);

  //Old code

  // let countdown = 60;
  // let intervalId;
  // let confirmDialogOpen = false;


  // const onIdle = () => {
  //   if (!isLoggedIn || confirmDialogOpen) return;
  //   confirmDialogOpen = true;


  //   const dialog = document.createElement('div');
  //   dialog.style.cssText = `
  //     position: fixed; top: 30%; left: 50%; transform: translate(-50%, -50%);
  //     background: white; border: 1px solid #ccc; padding: 20px; z-index: 10000;
  //     font-family: sans-serif; text-align: center;
  //   `;

  //   dialog.innerHTML = `
  //   <p id="countdownText">You have been inactive. Logging out in ${countdown} seconds...</p>
  //   <button id="stayLoggedInBtn">Stay Logged In</button>
  // `;

  //   document.body.appendChild(dialog);

  //   const countdownText = document.getElementById('countdownText');
  //   const stayLoggedInBtn = document.getElementById('stayLoggedInBtn');

  //   intervalId = setInterval(() => {
  //     countdown--;
  //     countdownText.textContent = `You have been inactive. Logging out in ${countdown} seconds...`;

  //     if (countdown <= 0) {
  //       clearInterval(intervalId);
  //       document.body.removeChild(dialog);
  //       handleLogout();
  //       confirmDialogOpen = false;
  //     }
  //   }, 1000);

  //   stayLoggedInBtn.onclick = () => {
  //     clearInterval(intervalId);
  //     document.body.removeChild(dialog);
  //     reset();
  //     confirmDialogOpen = false;
  //     countdown = 60;
  //   };
  // };



  // const { reset } = useIdleTimer({
  //   timeout: 30 * 60 * 1000,
  //   onIdle,
  //   debounce: 500,
  // });

  useEffect(() => {

    return () => {

      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

    };

  }, []);

  const onIdle = () => {

    if (!isLoggedIn || idlePopupOpenRef.current) return;

    idlePopupOpenRef.current = true;

    setShowIdlePopup(true);
    setCountdown(60);

    intervalRef.current = setInterval(() => {

      setCountdown((prev) => {

        if (prev <= 1) {

          clearInterval(intervalRef.current);

          idlePopupOpenRef.current = false;

          setShowIdlePopup(false);

          handleLogout();

          return 0;
        }

        return prev - 1;
      });

    }, 1000);
  };

  // const onIdle = () => {
  //   if (!isLoggedIn || idlePopupOpenRef.current) return;

  //   idlePopupOpenRef.current = true;
  //   setShowIdlePopup(true);
  //   setCountdown(60);

  //   // 1. Calculate the exact future timestamp when logout MUST happen
  //   const targetLogoutTime = Date.now() + 60 * 1000;

  //   intervalRef.current = setInterval(() => {
  //     const currentTime = Date.now();
  //     // 2. Find out remaining seconds based on real time, not interval ticks
  //     const remainingSeconds = Math.max(0, Math.ceil((targetLogoutTime - currentTime) / 1000));

  //     if (remainingSeconds <= 0) {
  //       // 3. Time is up! Clean up and log out
  //       clearInterval(intervalRef.current);
  //       idlePopupOpenRef.current = false;
  //       setShowIdlePopup(false);
  //       handleLogout();
  //     } else {
  //       // 4. Update UI countdown with accurate remaining time
  //       setCountdown(remainingSeconds);
  //     }
  //   }, 1000);
  //   // Even if this is throttled to run every few seconds, 
  //   // remainingSeconds will accurately jump down or hit 0 instantly on tab return.
  // };


  const handleStayLoggedIn = () => {

    clearInterval(intervalRef.current);

    idlePopupOpenRef.current = false;

    setShowIdlePopup(false);

    setCountdown(60);

    reset();
  };


  const { reset } = useIdleTimer({
    timeout: 5 * 60 * 1000,
    onIdle,
    debounce: 500,
  });


  
  // const breifcase_icon__sts = (
  //       expectedCompany,        
  //       projectAdminRoles = []
  //     ) => {
  //       return (
  //         (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')) ||          
  //         (getUserCompanyDetails === expectedCompany && userPermission === 'project_user' && projectAdminRoles.includes(userRoleManual))
  //       );
  //     };

      const breifcase_icon_sts = (
        expectedCompany,        
        projectAdminRoles = []
      ) => {
        var sts=(
          (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')) ||          
          // (getUserCompanyDetails === expectedCompany && userPermission === 'project_user' && projectAdminRoles.includes(userRoleManual)) ||
          // projectAdminRoles.includes(userRoleManual)
          projectAdminRoles.some(item=>userRoleManual?.includes?.(item))
        );
        return sts;
      };

      // const projlevel_icon__sts = (
      //   expectedCompany,        
      //   projectAdminRoles = []
      // ) => {
      //   var sts=(
      //     (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')) || (userRoleManual?.length===0 ||                  
      //     projectAdminRoles.some(item=>userRoleManual?.includes?.(item)))
      //   );
      //   return sts;
      // };

      // const projlevel_icon__sts = (
      //   expectedCompany,        
      //   projectAdminRoles = []
      // ) => {
      //   var sts=(
      //     (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin') && userRoleManual?.length===0) ||                  
      //     projectAdminRoles.some(item=>userRoleManual?.includes?.(item))
      //   );
      //   return sts;
      // };

      const projlevel_icon__sts = (
        expectedCompany,        
        projectAdminRoles = []
      ) => {
        var sts=(
          (getUserCompanyDetails === expectedCompany && proj_access_level === true) 
          || projectAdminRoles.some(item=>userRoleManual?.includes?.(item))
        );
        return sts;
      };

  return (
    <div className="bodywrap">
      {/* <div className="headerwrap">
        <header>
          <div className="headtitlewrap">
            <img src={nusLogo} alt="NUS Logo" className="logo" />
            <div className="headtitle">
              <h1>CONSTRUCTION PROJECT MANAGEMENT SYSTEM</h1>
              <h2>Executive Portal</h2>
            </div>
          </div>
        </header>
      </div> */}

      {/* updated code */}
      <div className="headerwrap">
        <header>
          <div className="headtitlewrap">
            <img src={nusLogo} alt="NUS Logo" className="logo" />
            <div className="headtitle">
              <h1>CONSTRUCTION PROJECT MANAGEMENT SYSTEM</h1>
              <h2>Executive Portal</h2>
            </div>
          </div>
          {isLoggedIn ? (
          <button className="logout-button"
           onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} />
          </button>
          ): null}
        </header>
      </div>


      {!isLoggedIn ? (
        <Routes>
          <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
          <Route path="/" element={<Login onLoginSuccess={handleLoginSuccess} />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      ) : (
        <div className="container">
           {loading && <FullscreenLoader />} 
          <div className="nav">
            <div className="top">
              <div className="navtoggle">
                <a href="#" onClick={toggleUserMenu} title="Account">
                  <FontAwesomeIcon icon={faUserCircle} className={`left ${userMenuVisible ? 'on' : ''}`} />
                </a>
                <a href="#" onClick={togglePlansMenu} title="Projects">
                  <FontAwesomeIcon icon={faBuilding} className={`right ${plansMenuVisible ? 'on' : ''}`} />
                </a>
              </div>

              {userMenuVisible && (
                <>
                  <Link
                    to="/homeacc"
                    className={activeLink === '/homeacc' ? 'active' : ''}
                    onClick={() => handleLinkClick('/homeacc')}
                    title="Home"
                  >
                    <FontAwesomeIcon icon={faHome} />
                  </Link>
                  {/* old code */}
                  {/* <Link
                    to="/dashboardacc"
                    className={activeLink === '/dashboardacc' ? 'active' : ''}
                    onClick={() => handleLinkClick('/dashboardacc')}
                  >
                    <FontAwesomeIcon icon={faTachometerAlt} />
                  </Link> */}

                  {/* <Link
                    to="/dashboardacc"
                    className={activeLink === '/dashboardacc' ? 'active' : ''}
                    onClick={(e) => {  handleLinkClick('/dashboardacc'); }}
                    title="Account Dashboards"
                  >
                    <FontAwesomeIcon icon={faTachometerAlt} />
                  </Link> */}
                  {/* {((userPermission === 'project_admin' || userPermission === 'account_admin') && getUserCompanyDetails === 'NUS') ? ( */}
                  {(userPermission === 'account_admin' && getUserCompanyDetails === 'NUS') ? (
                    <>
                    <Link
                    to="/dashboardacc"
                    className={activeLink === '/dashboardacc' ? 'active' : ''}
                    onClick={(e) => {  handleLinkClick('/dashboardacc'); }}
                    title="Account Dashboards"
                  >
                    <FontAwesomeIcon icon={faTachometerAlt} />
                  </Link>

                      <Link
                        to="/checklistacc"
                        className={`${activeLink === '/checklistacc' ? 'active' : ''} ${(userPermission ==='account_admin' || userPermission === 'project_admin') && getUserCompanyDetails === 'NUS' ? '' : 'disabled'}`}
                        onClick={(e) => {
                          if ((userPermission === 'project_admin' || userPermission === 'account_admin') && getUserCompanyDetails === 'NUS') {
                            handleLinkClick('/checklistacc'); 
                          } else {
                            e.preventDefault();  
                          }
                        }}
                          title="Account Reports"
                      >
                        <FontAwesomeIcon icon={faListAlt} />
                      </Link>
                      </>
                   ) : null}

                </>
              )}

              {plansMenuVisible &&(
                <>
                {(projlevel_icon__sts("NUS",['Consultant','Contractor','Project Manager (PM)','Admin'])) ?(
                  <Link
                    to="/plans"
                    className={activeLink === '/plans' ? 'active' : ''}
                    onClick={() => handleLinkClick('/plans')}
                    title='WIP'
                  >
                    <FontAwesomeIcon icon={faBriefcase} className="faBriefcase" />
                  </Link>
                ):null}

                {(projlevel_icon__sts("NUS",['Admin & Contract (AC)','Project Manager (PM)','Admin']))?(
                  <>

                  {(projlevel_icon__sts("NUS",['Admin & Contract (AC)','Project Manager (PM)','Admin'])) ?(
                  <Link
                    to="/funds"                    
                    title='PIF'
                    className={activeLink === '/funds' ? 'active' : ''}
                    onClick={() => handleLinkClick('/funds')}
                    >
                    <FontAwesomeIcon icon={faDollarSign} className="faDollarSign" />
                  </Link>
                ):null}
                  

                  <Link
                    to="/dashboard"                    
                    title='Project Dashboards'
                    className={activeLink === '/dashboard' ? 'active' : ''}
                    onClick={() => handleLinkClick('/dashboard')}
                  >
                    <FontAwesomeIcon icon={faTachometerAlt} />
                  </Link>

                  <Link
                    to="/checklist"
                    className={activeLink === '/checklist' ? 'active' : ''}
                    onClick={() => handleLinkClick('/checklist')}
                    title='Project Reports'
                  >
                    <FontAwesomeIcon icon={faListAlt} />
                  </Link>
                  </>
                ):null}
                  

                  {/* {((userPermission === 'project_admin' || userPermission === 'account_admin') && getUserCompanyDetails === 'NUS') ? (
                  <Link
                    to="/funds"
                    className={`${activeLink === '/funds' ? 'active' : ''} ${(userPermission === 'project_admin' || userPermission === 'account_admin') && getUserCompanyDetails === 'NUS' ? '' : 'disabled'}`}
                    onClick={(e) => {
                      if ((userPermission !== 'account_admin' || userPermission !== 'project_admin') && getUserCompanyDetails !== 'NUS') {
                        e.preventDefault(); 
                      } else {
                        handleLinkClick('/funds');  
                      }
                    }}
                    title='PIF'
                    // className={activeLink === '/funds' ? 'active' : ''}
                    // onClick={() => handleLinkClick('/funds')}
                  >
                    <FontAwesomeIcon icon={faDollarSign} className="faDollarSign" />
                  </Link>
                  ):null}
                  {((userPermission === 'project_admin' || userPermission === 'account_admin') && getUserCompanyDetails === 'NUS') ? (
                  <Link
                    to="/dashboard"
                    className={`${activeLink === '/dashboard' ? 'active' : ''} ${(userPermission !== 'account_admin' || userPermission !== 'project_admin') && getUserCompanyDetails !== 'NUS' ? 'disabled' : ''}`}
                    onClick={(e) => {
                      if ((userPermission !== 'account_admin' || userPermission !== 'project_admin') && getUserCompanyDetails !== 'NUS') {
                        e.preventDefault(); 
                      } else {
                        handleLinkClick('/dashboard');  
                      }
                    }}
                    title='Project Dashboards'
                    // className={activeLink === '/dashboard' ? 'active' : ''}
                    // onClick={() => handleLinkClick('/dashboard')}
                  >
                    <FontAwesomeIcon icon={faTachometerAlt} />
                  </Link>
                  ):null}
                  <Link
                    to="/checklist"
                    className={activeLink === '/checklist' ? 'active' : ''}
                    onClick={() => handleLinkClick('/checklist')}
                    title='Project Reports'
                  >
                    <FontAwesomeIcon icon={faListAlt} />
                  </Link> */}
                </>
              )}
            </div>

            <div className="bottom">
            
              <button className="btntopright" id="settingsBtn" onClick={toggleSettings}>
                <a className="active" href="#"><FontAwesomeIcon icon={faCog} title="Settings" /></a>
              </button>
          
              {/* Settings popup */}
              {showSettings && (
                <div className="settings-popup" id="settingsPopup" ref={settingsPopupRef} style={{ display: 'flex' }}>
                  {/* <button className="setting-btn" onClick={handleManageAccount}>
                    Manage {userMenuVisible ? "Account":"Project"} Members
                  </button> */}
                  {(userPermission === 'account_admin' && getUserCompanyDetails === 'NUS')?(
                    <button className="setting-btn" onClick={handleManageAccount}>
                    Manage {userMenuVisible ? "Account":"Project"} Members
                  </button>
                  ):null}
                  <button className="setting-btn" onClick={handleClick}>Profile</button>
                  <button className="setting-btn" onClick={handleLogout}>Logout</button>
                </div>
              )}
            </div>
          </div>

          <div className="wbshor">
            <ToastContainer />
            <Routes>
              <Route path="/profile" element={<Profile />} />
              <Route path="/funds" element={<RouteGuard><Funds /></RouteGuard>} />
              <Route path="/homeacc" element={<Homeacc />} />
              <Route path="/dashboardacc" element={<Dashboardacc />} />
              <Route path="/checklistacc" element={<ChecklistAcc />} />
              <Route path="/plans" element={<RouteGuard><Plans /></RouteGuard>} />
              <Route path="/checklist" element={<RouteGuard><Checklist /></RouteGuard>} />
              <Route path="/dashboard" element={<RouteGuard><Dashboard /></RouteGuard>} />
              <Route path="*" element={<Navigate to="/homeacc" />} />
            </Routes>
          </div>
        </div>
      )}
    
    {/* Single tab restriction popup */}
      {blockTab && (
        <div style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999999
        }}>
          <div style={{
            background: "#fff",
            padding: "20px 30px",
            borderRadius: "8px",
            textAlign: "center"
          }}>
            <h3>🚫 Multiple Tabs Detected</h3>
            <p>Please close other tabs to continue using this application.</p>
          </div>
        </div>
      )}

      {/* Idle User session popup */}
      {showIdlePopup && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999999,
          }}
        >
          <div
            style={{
              background: '#fff',
              padding: '25px',
              borderRadius: '10px',
              textAlign: 'center',
              minWidth: '320px',
              boxShadow: '0 0 10px rgba(0,0,0,0.3)',
            }}
          >
            <h3>Session Timeout</h3>

            <p>
              You have been inactive.
            </p>

            <p>
              Logging out in <b>{countdown}</b> seconds...
            </p>

            <button
              onClick={handleStayLoggedIn}
              style={{
                padding: '10px 20px',
                cursor: 'pointer',
                backgroundColor:'#dbdbdb'
              }}
            >
              Stay Logged In
            </button>
          </div>
        </div>
      )}

    </div>
    
  );
}

export default App;
